import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_INFLOW = 0;
const DEFAULT_MAX_INFLOW = 100;

export const inflowDescriptor = defineFilter({
  definition: {
    id: FilterId.INFLOW,
    name: 'Inflow',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_INFLOW,
    max: DEFAULT_MAX_INFLOW,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_INFLOW, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(DEFAULT_MIN_INFLOW, DEFAULT_MAX_INFLOW),
});
